import { Component, OnInit, ViewChild, WritableSignal, AfterViewInit } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService, FilterService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { GarantieEntite, TypeGarantieEntite } from 'src/app/entites/garantie';
import { GarantieService } from 'src/app/services/garantie-service';
import { environment } from 'src/environments/environment';
import { Emplacement } from 'src/app/entites/emplacement';
import { RapportService } from 'src/app/services/rapport-service';
import { AttributEntite } from "src/app/entites/attribut";
import { ETypeChampAttribut } from "src/app/entites/enums/type-champ";

@Component({
    templateUrl: './garanties.component.html',
    styleUrls: ['./garanties.component.scss'],
    providers: [MessageService, DialogService]
})
export class GarantiesComponent extends BaseComponent implements OnInit, AfterViewInit {

    itemsComplet: GarantieEntite[];
    items: GarantieEntite[];
    selectionItem: GarantieEntite;

    attributs: AttributEntite[];

    types: TypeGarantieEntite[];
    type: WritableSignal<TypeGarantieEntite> = this.createParamSignal('type', null, 'typeGarantieId');

    menuContextuelItems: MenuItem[];

    seuilRouge = environment.parametres.garanties.seuilRouge;
    seuilJaune = environment.parametres.garanties.seuilJaune;

    assignations: string[];
    selectionAssignations: string[];
    assignationSelection: WritableSignal<string> = this.createParamSignal('assignation', null);

    tableParams = this.createTableFilter();

    globalFilter: string = '';

    @ViewChild('dt') table: Table;
    @ViewChild('menuContxtuelItem') menuContxtuelItem: ContextMenu;

    constructor(
        public sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private ItemsService: ItemService,
        private garantieService: GarantieService,
        private messageService: MessageService,
        private rapportService: RapportService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        private filterService: FilterService) {
        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Garanties' }
        ]);

        // Register custom filter for assignation that checks if any selected value is contained in the field
        this.filterService.register('assignationContains', (value: string, filter: string[]): boolean => {
            if (!filter || filter.length === 0) return true;
            if (!value) return false;
            return filter.some(f => value.includes(f));
        });

        if (
            this.profilService.Profil().roles.some(x => x.nom === 'SIHC_ChargeProjet') &&
            !this.routerService.url.includes('?')
        ) {
            const emplacementsCP = this.sdb.EmplacementsComplet().filter(x =>
                this.profilService.Profil().employe.emplacementIdsCP.includes(x.emplacementId)
            );

            if (emplacementsCP.length > 0) {
                const assignationValues = emplacementsCP.map(x => x.nom);
                const filters = {
                    assignation: [
                        {
                            value: assignationValues,
                            matchMode: "assignationContains",
                            operator: "and"
                        }
                    ]
                };

                this.routerService.navigate([], {
                    relativeTo: this.route,
                    queryParams: { rows: 100, filters: JSON.stringify(filters) },
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                });
            }
        }
    }


    ngOnInit() {

        this.colonnesDisponibles = [
            { base: true, champ: 'description', entete: 'Description', afficheParDefaut: true },
            { base: true, champ: 'categorie', entete: 'Catégorie', afficheParDefaut: false },
            { base: true, champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: false },
            { base: true, champ: 'marque', entete: 'Marque', afficheParDefaut: false },
            { base: true, champ: 'modele', entete: 'Modèle', afficheParDefaut: false },
            { base: true, champ: 'type', entete: 'Type', afficheParDefaut: true },
            { base: true, champ: 'description2', entete: 'Description Garantie', afficheParDefaut: true },
            { base: true, champ: 'statut', entete: 'Statut', afficheParDefaut: true },
            { base: true, champ: 'dateFin', entete: 'Date de fin', afficheParDefaut: true },
            { base: true, champ: 'nbJoursRestants', entete: 'Nb jours restants', afficheParDefaut: true },
        ];

        this.attributs = this.sdb.Attributs();

        this.attributs.forEach(att => {
            this.colonnesDisponibles.push({
                base: false,
                champ: 'att' + att.attributId,
                entete: att.nom,
                afficheParDefaut: false,
                type: att.typeChamp
            });
        });

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.types = this.sdb.TypesGarantie();
        this.type.set(this.types.find(x => x.typeGarantieId == this.type()?.typeGarantieId));

        this.assignations = this.sdb.Emplacements().map(x => x.nom).concat(this.sdb.Employes().map(x => x.prenom + ' ' + x.nom));
        this.selectionAssignations = [];
        this.assignationSelection.set(this.assignations.find(x => x == this.assignationSelection()));

        this.garantieService.ObtenirListe().then(x => {
            this.itemsComplet = x.valeur;
            // Populate garantie.item with attribute fields (attX)
            this.itemsComplet = this.itemsComplet.map(garantie => {
                if (garantie.item && Array.isArray(garantie.item.valeursAttributs)) {
                    garantie.item.valeursAttributs.forEach(val => {
                        garantie.item['att' + val.attribut.attributId] = val.valeur;
                    });
                }
                return garantie;
            });
            // Add assignation property to each garantie for filtering
            this.itemsComplet.forEach(garantie => {
                garantie['assignation'] = this.getAssignation(garantie);
            });
            this.filtrer();
            this.CompleterChargement();
        });

    }

    ngAfterViewInit() {
        this.globalFilter = this.tableParams.getValue().globalFilter;
        this.chargerColonnesSelectionnees();
    }

    surMenuContextuelItem(event, garantie: GarantieEntite) {
        this.selectionItem = garantie;
        this.menuContextuelItems = this.ItemsService.getItemActions(this.selectionItem.item);
        this.menuContxtuelItem.toggle(event);
        setTimeout(() => {
            (this.menuContxtuelItem as any).dirty = true;
        }, 0);
    }


    filtrer() {
        this.Bloquer();
        this.items = this.itemsComplet;
        if (this.type()) {
            this.items = this.items.filter(x => x.type?.typeGarantieId == this.type().typeGarantieId);
        }
        if (this.assignationSelection()) {
            // Use includes to match both direct assignment and employee's current emplacement
            this.items = this.items.filter(x => this.getAssignation(x).includes(this.assignationSelection()));
        }

        // Update assignation property for filtered items
        this.items.forEach(garantie => {
            garantie['assignation'] = this.getAssignation(garantie);
        });

        this.Debloquer();
    }

    retirerFiltres() {
        this.items = this.itemsComplet;
        this.type.set(null);
        this.assignationSelection.set(null);
        this.selectionAssignations = [];

        // Update assignation property for all items
        this.items.forEach(garantie => {
            garantie['assignation'] = this.getAssignation(garantie);
        });
    }

    /**
     * Build assignation string for filtering - includes employee name AND their current emplacement.
     * This allows filtering by emplacement to also find items assigned to employees currently at that emplacement.
     */
    getAssignation(garantie: GarantieEntite): string {
        if (garantie.item.employe) {
            let assignation = garantie.item.employe.prenom + ' ' + garantie.item.employe.nom;
            // Add employee's current emplacement for filtering purposes
            if (garantie.item.emplacementCourantEmploye?.nom) {
                assignation += '|' + garantie.item.emplacementCourantEmploye.nom;
            }
            return assignation;
        } else if (garantie.item.emplacement) {
            return garantie.item.emplacement.nom;
        }
        return '';
    }

    exportExcel() {

        var t = this.table.value;

        if (this.table.filteredValue) {
            t = this.table.filteredValue;
        }

        var lignes: any[] = t.map(x => ({
            NumeroItem: x.item.numero ? x.item.numero : '',
            DescriptionItem: x.item.description ? x.item.description : '',
            Type: x.type?.nom ? x.type?.nom : '',
            Statut: x.statut.nom ? x.statut.nom : '',
            Description: x.description ? x.description : '',
            DateFin: x.dateFin ? x.dateFin : '',
            NbJoursRestants: x.nbJoursRestants ? x.nbJoursRestants : '',
            Assignation: this.getAssignation(x)
        }));

        for (let index = 0; index < lignes.length; index++) {
            if (this.colonnesSelectionnees.filter(x => x.champ == 'categorie').length == 1) {
                if (t[index].item.categorie && t[index].item.categorie.nom) {
                    lignes[index].Categorie = t[index].item.categorie?.nom;
                } else {
                    lignes[index].Categorie = '';
                }
                lignes[index].Categorie = t[index].categorie?.nom;
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'sousCategorie').length == 1) {
                if (t[index].item.sousCategorie && t[index].item.sousCategorie.nom) {
                    lignes[index].SousCategorie = t[index].item.sousCategorie?.nom;
                } else {
                    lignes[index].SousCategorie = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'marque').length == 1) {
                if (t[index].item.marque) {
                    lignes[index].Marque = t[index].item.marque;
                } else {
                    lignes[index].Marque = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'modele').length == 1) {
                if (t[index].item.modele) {
                    lignes[index].Modele = t[index].item.modele;
                } else {
                    lignes[index].Modele = '';
                }
            }
            for (let i = 0; i < this.colonnesSelectionnees.filter(x => !x.base).length; i++) {
                let colonne = this.colonnesSelectionnees.filter(x => !x.base)[i];
                if (t[index].item[colonne.champ]) {
                    lignes[index][colonne.entete] = t[index].item[colonne.champ];
                } else {
                    lignes[index][colonne.entete] = '';
                }
            }
        }



        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });

        this.rapportService.ProduireRapportExcel({
            contenu: JSON.stringify(lignes),
            formatsColonnes: [
                {
                    nomColonne: 'NbJoursRestants',
                    type: 0, // TypeFormatage.SeuilsCouleur
                    parametres: {
                        seuilRouge: this.seuilRouge,
                        seuilJaune: this.seuilJaune,
                        couleurRouge: '#FFCCCB',
                        couleurJaune: '#FFFFE0',
                        couleurVert: '#90EE90'
                    }
                }
            ]
        }).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });


    }

    get ETypeChampAttribut() {
        return ETypeChampAttribut;
    }
}
